import { render, staticRenderFns } from "./LoanRequestTab.vue?vue&type=template&id=7983ac7e&"
import script from "./LoanRequestTab.vue?vue&type=script&lang=js&"
export * from "./LoanRequestTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports